import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import {
  maxLength,
  required,
  nullable,
} from '../../shared/forms/validators';
import { hideField } from '../../shared/forms/constants';

const isOpenForEdit = ({ formContext }) => formContext.openForEdit;

const schema = [
  {
    name: 'localAccount',
    component: InputFormik,
    meta: { label: 'Local Account' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, maxLength(30)] },
    additionalProps: { required: true },
  },
  {
    name: 'localAccountDescription',
    component: InputFormik,
    meta: { label: 'Local Account Description' },
    options: { yupType: yupString(), validationRules: [required, maxLength(256)] },
    additionalProps: { required: true },
  },
  {
    name: 'r2rAccount',
    component: SelectFormik,
    meta: { label: 'Matching ES Chart Account', optionsKey: 'r2rAccountOptions' },
    options: { yupType: yupString(), validationRules: [required, maxLength(256)] },
    additionalProps: { required: true, virtualized: true },
  },
  {
    name: 'importStatusDetail',
    component: SelectFormik,
    meta: { label: 'Import Status', optionsKey: 'importStatusOptions' },
    options: { yupType: yupString(), validationRules: [nullable, maxLength(256)] },
    conditions: [
      {
        when: isOpenForEdit,
        then: {
          additionalProps: { virtualized: true },
        },
        otherwise: hideField,
      },
    ],
  },
  {
    name: 'importValidation',
    component: InputFormik,
    meta: { label: 'Import Note' },
    options: { yupType: yupString(), validationRules: [nullable, maxLength(256)] },
    conditions: [
      {
        when: isOpenForEdit,
        then: {},
        otherwise: hideField,
      },
    ],
  },
];

export default schema;
